// DO NOT EDIT -- generated from fs/services/alexa/conversions.proto

import * as protobuf from '../../../google/protobuf';
import * as search from '../../api/search';
import * as segment from '../../api/segment';

/** Step defines the logical step of a conversion funnel, w.r.t to an input. */
export interface Step {
  name: string;
  /** count of users at this step of the conversion funnel,  who experience/match a particular input. */
  affectedUsers: protobuf.int64;
  /** count of users at this step of the conversion funnel, who do not experience/match a particular input. */
  unaffectedUsers: protobuf.int64;
  /** impact stats for this step. Set only for stepwise impact. */
  stepStats: ImpactStats | null;
}

/** Next ID: 17 */
export enum ImpactType {
  IMPACT_TYPE_INVALID = 0,
  IMPACT_TYPE_BAD_CLICK = 1,
  IMPACT_TYPE_PERF_EVENT = 2,
  IMPACT_TYPE_CUSTOM_EVENT = 3,
  IMPACT_TYPE_SEEN_EVENT = 4,
  /** @deprecated */
  IMPACT_TYPE_CUSTOM_QUERY = 5,
  IMPACT_TYPE_DEFINED_EVENT = 6,
  IMPACT_TYPE_AJAX_ERROR = 7,
  /** @deprecated */
  IMPACT_TYPE_CORE_WEB_VITALS = 8,
  IMPACT_TYPE_PAGE_VIEW = 9,
  IMPACT_TYPE_FID = 10,
  IMPACT_TYPE_CLS = 11,
  IMPACT_TYPE_LCP = 12,
  IMPACT_TYPE_INP = 13,
  IMPACT_TYPE_TTI = 14,
  IMPACT_TYPE_TBT = 15,
  IMPACT_TYPE_TTFB = 16
}

export enum BadClickType {
  CLICK_TYPE_INVALID = 0,
  CLICK_TYPE_RAGE = 1,
  CLICK_TYPE_ERROR = 2,
  CLICK_TYPE_DEAD = 3
}

/**
 * NB Because of recent shifting definitions, we decided everything here would be presented as just "web vitals"
 * The "core" designation is vestigial
 */
export enum CoreWebVitalType {
  CORE_WEB_VITAL_TYPE_INVALID = 0,
  CORE_WEB_VITAL_TYPE_FIRST_INPUT_DELAY = 1,
  CORE_WEB_VITAL_TYPE_CUMULATIVE_LAYOUT_SHIFT = 2,
  CORE_WEB_VITAL_TYPE_LARGEST_CONTENTFUL_PAINT = 3,
  WEB_VITAL_TYPE_INTERACTION_TO_NEXT_PAINT = 4,
  WEB_VITAL_TYPE_TIME_TO_INTERACTIVE = 5,
  WEB_VITAL_TYPE_TOTAL_BLOCKING_TIME = 6,
  WEB_VITAL_TYPE_TIME_TO_FIRST_BYTE = 7
}

export interface PerfEventMetadata {
  /** load time range */
  rangeStart: string;
  rangeEnd: string;
}

export interface CoreWebVitalMetadata {
  /** core web vital threshold ranges and type */
  rangeStart: string;
  rangeEnd: string;
  coreWebVital: CoreWebVitalType;
  isMobile: boolean;
}

/** Impact stats are always computed between two steps of a funnel */
export interface ImpactStats {
  /** conversion is defined as the fraction of users who make it to the end of the funnel */
  affectedConversion: number;
  unaffectedConversion: number;
  /**
   * always computed as (affected_conversion - unaffected_conversion) / unaffected_conversion
   * provided that unaffected_conversion is not zero.
   */
  conversionDelta: number;
  /** as determined by a statistical test of significance */
  isSignificant: boolean;
  /** to determine the index of the steps for which the impact is computed */
  fromIndex: number;
  toIndex: number;
  conversionsLost: protobuf.int64;
  confidence: number;
}

export enum ImpactScope {
  IMPACT_SCOPE_INVALID = 0,
  IMPACT_SCOPE_OVERALL = 1,
  IMPACT_SCOPE_STEPWISE = 2,
  IMPACT_SCOPE_NEGATIVE_INSIGNIFICANT = 3,
  /** @deprecated */
  IMPACT_SCOPE_AFFECTED_SIGNIFICANT = 4
}

/**
 * Impact computes the impact to conversion due to a particular kind of input. For example, impact of an error click on conversion.
 * NEXT ID: 15
 */
export interface Impact {
  /** unique identifier for the impact. */
  label: string;
  /** funnel counts */
  steps: Step[];
  impactType: ImpactType;
  clickType?: BadClickType;
  performanceMetadata?: PerfEventMetadata | null;
  customevent?: CustomEvent | null;
  seenEventName?: string;
  definedEventId?: string;
  coreWebVitalMetadata?: CoreWebVitalMetadata | null;
  pageView?: PageView | null;
  /** overall impact stats and scope for the conversion funnel */
  impactStats: ImpactStats | null;
  impactScope: ImpactScope;
}

/**
 * Impact computes the impact to conversion due to a particular kind of input. For example, impact of an error click on conversion.
 * NEXT ID: 15
 */
export namespace Impact {
  export enum metadata {
    clickType = 4,
    performanceMetadata = 5,
    customevent = 6,
    seenEventName = 8,
    definedEventId = 12,
    coreWebVitalMetadata = 13,
    pageView = 14
  }

  export function metadata_oneof(m: Impact): { opt: metadata.clickType, val: BadClickType } | { opt: metadata.coreWebVitalMetadata, val: CoreWebVitalMetadata } | { opt: metadata.customevent, val: CustomEvent } | { opt: metadata.definedEventId, val: string } | { opt: metadata.pageView, val: PageView } | { opt: metadata.performanceMetadata, val: PerfEventMetadata } | { opt: metadata.seenEventName, val: string } | null {
    if (m.clickType != null) { return { opt: metadata.clickType, val: m.clickType } }
    if (m.performanceMetadata != null) { return { opt: metadata.performanceMetadata, val: m.performanceMetadata } }
    if (m.customevent != null) { return { opt: metadata.customevent, val: m.customevent } }
    if (m.seenEventName != null) { return { opt: metadata.seenEventName, val: m.seenEventName } }
    if (m.definedEventId != null) { return { opt: metadata.definedEventId, val: m.definedEventId } }
    if (m.coreWebVitalMetadata != null) { return { opt: metadata.coreWebVitalMetadata, val: m.coreWebVitalMetadata } }
    if (m.pageView != null) { return { opt: metadata.pageView, val: m.pageView } }
    return null;
  }
}

export interface CustomEvent {
  name?: string;
  slug?: string;
  properties: ApiEventProperty[];
}

export namespace CustomEvent {
  export enum id {
    name = 1,
    slug = 3
  }

  export function id_oneof(m: CustomEvent): { opt: id.name, val: string } | { opt: id.slug, val: string } | null {
    if (m.name != null) { return { opt: id.name, val: m.name } }
    if (m.slug != null) { return { opt: id.slug, val: m.slug } }
    return null;
  }
}

export interface PageView {
  pageDefId?: protobuf.int64;
  specSlug?: string;
  properties: ApiEventProperty[];
}

export namespace PageView {
  export enum id {
    pageDefId = 1,
    specSlug = 3
  }

  export function id_oneof(m: PageView): { opt: id.pageDefId, val: protobuf.int64 } | { opt: id.specSlug, val: string } | null {
    if (m.pageDefId != null) { return { opt: id.pageDefId, val: m.pageDefId } }
    if (m.specSlug != null) { return { opt: id.specSlug, val: m.specSlug } }
    return null;
  }
}

export interface ApiEventProperty {
  propertyName: string;
  propertyValues: string[];
}

/** To support watched element (seen event) as input */
export interface SeenEvent {
  /** name of the element. */
  name: string;
  /**
   * deprecated on 01/04/24 because non named elements are deprecated
   * 
   * @deprecated
   */
  targetSelector?: string;
  targetNamedElementId?: string;
  targetSlug?: string;
  /** supplied target text values for the element */
  targetTextValues: string[];
  filterText?: boolean;
  filterDuration?: protobuf.int64;
}

/** To support watched element (seen event) as input */
export namespace SeenEvent {
  /** CSS selector, named element id, or spec slug of the element. */
  export enum target {
    /**
     * deprecated on 01/04/24 because non named elements are deprecated
     * 
     * @deprecated
     */
    targetSelector = 2,
    targetNamedElementId = 4,
    targetSlug = 7
  }

  /** CSS selector, named element id, or spec slug of the element. */
  export function target_oneof(m: SeenEvent): { opt: target.targetNamedElementId, val: string } | { opt: target.targetSelector, val: string } | { opt: target.targetSlug, val: string } | null {
    if (m.targetSelector != null) { return { opt: target.targetSelector, val: m.targetSelector } }
    if (m.targetNamedElementId != null) { return { opt: target.targetNamedElementId, val: m.targetNamedElementId } }
    if (m.targetSlug != null) { return { opt: target.targetSlug, val: m.targetSlug } }
    return null;
  }

  export enum filter {
    filterText = 5,
    filterDuration = 6
  }

  export function filter_oneof(m: SeenEvent): { opt: filter.filterDuration, val: protobuf.int64 } | { opt: filter.filterText, val: boolean } | null {
    if (m.filterText != null) { return { opt: filter.filterText, val: m.filterText } }
    if (m.filterDuration != null) { return { opt: filter.filterDuration, val: m.filterDuration } }
    return null;
  }
}

/** Next ID: 17 */
export enum SignalType {
  SIGNAL_TYPE_INVALID = 0,
  SIGNAL_TYPE_BAD_CLICK = 1,
  SIGNAL_TYPE_PERF_EVENT = 2,
  SIGNAL_TYPE_CUSTOM_EVENT = 3,
  SIGNAL_TYPE_SEEN_EVENT = 4,
  /** @deprecated */
  SIGNAL_TYPE_CUSTOM = 5,
  SIGNAL_TYPE_DEFINED_EVENT = 6,
  SIGNAL_TYPE_AJAX_ERROR = 7,
  /** @deprecated */
  SIGNAL_TYPE_CORE_WEB_VITALS = 8,
  SIGNAL_TYPE_PAGE_VIEW = 9,
  SIGNAL_TYPE_FID = 10,
  SIGNAL_TYPE_CLS = 11,
  SIGNAL_TYPE_LCP = 12,
  SIGNAL_TYPE_INP = 13,
  SIGNAL_TYPE_TTI = 14,
  SIGNAL_TYPE_TBT = 15,
  SIGNAL_TYPE_TTFB = 16
}

/**
 * A signal represents a search event and additional metadata
 * that can be used to generate a Conversion Opportunity (impact)
 * Next ID: 14
 */
export interface Signal {
  /** Type of the signal. */
  type: SignalType;
  /** User visible label for the signal. */
  label: string;
  /** event for the signal */
  event: segment.Event | null;
  clickType?: BadClickType;
  performanceMetadata?: PerfEventMetadata | null;
  customevent?: CustomEvent | null;
  seenEventName?: string;
  definedEventId?: string;
  coreWebVital?: CoreWebVitalMetadata | null;
  pageView?: PageView | null;
  /** Hash key used to identify a Signal, used for muting opportunities */
  signalKey: string;
}

/**
 * A signal represents a search event and additional metadata
 * that can be used to generate a Conversion Opportunity (impact)
 * Next ID: 14
 */
export namespace Signal {
  /** metadata associated with the signal. */
  export enum signal_metadata {
    clickType = 4,
    performanceMetadata = 5,
    customevent = 6,
    seenEventName = 7,
    definedEventId = 10,
    coreWebVital = 12,
    pageView = 13
  }

  /** metadata associated with the signal. */
  export function signal_metadata_oneof(m: Signal): { opt: signal_metadata.clickType, val: BadClickType } | { opt: signal_metadata.coreWebVital, val: CoreWebVitalMetadata } | { opt: signal_metadata.customevent, val: CustomEvent } | { opt: signal_metadata.definedEventId, val: string } | { opt: signal_metadata.pageView, val: PageView } | { opt: signal_metadata.performanceMetadata, val: PerfEventMetadata } | { opt: signal_metadata.seenEventName, val: string } | null {
    if (m.clickType != null) { return { opt: signal_metadata.clickType, val: m.clickType } }
    if (m.performanceMetadata != null) { return { opt: signal_metadata.performanceMetadata, val: m.performanceMetadata } }
    if (m.customevent != null) { return { opt: signal_metadata.customevent, val: m.customevent } }
    if (m.seenEventName != null) { return { opt: signal_metadata.seenEventName, val: m.seenEventName } }
    if (m.definedEventId != null) { return { opt: signal_metadata.definedEventId, val: m.definedEventId } }
    if (m.coreWebVital != null) { return { opt: signal_metadata.coreWebVital, val: m.coreWebVital } }
    if (m.pageView != null) { return { opt: signal_metadata.pageView, val: m.pageView } }
    return null;
  }
}

/** The analysis mode determines whether to aggregate by unique users or unique sessions. */
export enum AnalysisMode {
  ANALYSIS_MODE_INVALID = 0,
  /** count unique indvs with matching events across one or more sessions(s) */
  ANALYSIS_MODE_INDV_ACROSS_SESSIONS = 1,
  /** count unique indvs with matching events within same session */
  ANALYSIS_MODE_INDV_SAME_SESSION = 2,
  /** count sessions with matching events */
  ANALYSIS_MODE_SESSIONS = 3
}

export interface ConversionParams {
  /** the time range for which the analysis is performed */
  analysisTimeRange: segment.TimeRange | null;
  /** the segment definition for the audience/cohort of users. */
  segmentDefinition: segment.SegmentDefinition | null;
  /** the event sequence for a conversion funnel, expects ordered and more than one event filter. */
  funnelEventSequence: segment.EventSequence | null;
  /**
   * Determines whether the funnel events happen
   * in same session or across multiple sessions
   * 
   * @deprecated
   */
  requireSameSession: boolean;
  /** Determines the analysis mode */
  analysisMode: AnalysisMode;
}

export interface Opportunity {
  /** label for the impact. */
  label: string;
  /**
   * funnel step counts for affected and unaffected users
   * along with step stats, if any.
   */
  steps: Step[];
  /** overall stats and scope for the conversion funnel. */
  impactStats: ImpactStats | null;
  impactScope: ImpactScope;
  /** signal that resulted in the opportunity. */
  signal: Signal | null;
  /** ComputedAt is when the opportunity was computed. */
  computedAt: protobuf.timestamp | null;
}

/** Serves as the cache key for an opportunity */
export interface OpportunityCacheKey {
  /** Signal that generates the opportunity */
  signal: Signal | null;
  /** Conversion funnel, Cohort and time range */
  params: ConversionParams | null;
  searchCacheKey: search.CacheKey | null;
  now: protobuf.timestamp | null;
  timezone: string;
  /**
   * Whether or not we think funnel facets will be used.
   * Will allow for testing new flag w/o affecting cached data for customers.
   */
  useFunnelFacet: boolean;
}

export enum DimensionType {
  DIMENSION_TYPE_INVALID = 0,
  DIMENSION_TYPE_BROWSER = 1,
  DIMENSION_TYPE_DEVICE = 2,
  DIMENSION_TYPE_REFERRER = 3,
  DIMENSION_TYPE_CITY = 4,
  DIMENSION_TYPE_OS = 5,
  DIMENSION_TYPE_SCREEN = 6,
  DIMENSION_TYPE_UTM_SRC = 7,
  DIMENSION_TYPE_UTM_MED = 8,
  DIMENSION_TYPE_LOCATION = 9
}

export interface Dimension {
  type: DimensionType;
  /** Stats are a list of statistics for this DimensionType. */
  stats: DimensionValueStats[];
  /** ComputedAt is when the statistics were computed. */
  computedAt: protobuf.timestamp | null;
}

export interface DimensionValueStats {
  label: string;
  affConvCount: protobuf.int64;
  affFailCount: protobuf.int64;
  unaffConvCount: protobuf.int64;
  unaffFailCount: protobuf.int64;
  type: DimensionType;
  /** ComputedAt is when the statistics were computed. */
  computedAt: protobuf.timestamp | null;
  isSignificant: boolean;
  confidence: number;
}

/** This represents a Type/Label pair that can be used as dependent filter when calculating Dimension Statistics */
export interface DimensionFilter {
  type: DimensionType;
  label: string;
}

/** Serves as the cache key for computing dimensions */
export interface DimensionFilterCacheKey {
  /** Signal that generates the opportunity */
  signal: Signal | null;
  /** Conversion funnel, Cohort and time range */
  params: ConversionParams | null;
  /** The DimensionFilter is a Type/Label pair such as Browser:Chrome */
  dimensionFilter: DimensionFilter | null;
  /** The beginning step of the selected Conversions Opportunity. This is a zero-based index. */
  impactStep: protobuf.int64;
  searchCacheKey: search.CacheKey | null;
  now: protobuf.timestamp | null;
  timezone: string;
  /**
   * Whether or not we think funnel facets will be used.
   * Will allow for testing new flag w/o affecting cached data for customers.
   */
  useFunnelFacet: boolean;
}
